module.exports = __webpack_public_path__ + "static/media/image_natureworks.69ab743d.png";